export const headerConstants = {
  sacContextKey: 'sac-cxt',
  sacSessionIdKey: 'SAC-SessionId',
  schwabClientIdsKey: 'Schwab-Client-Ids'
};
